import { useEffect, useRef } from 'react';
import { useSelector, useDispatch } from 'react-redux';
import { store } from '../../store';
import { app_actions } from '../../actions/app_actions';
import { api_service } from '../../api/api_service';
import { api_urls } from '../../api/api_urls';
import { utility } from '../../utils';
import constants from '../../config/constants';
import i18n from '../../config/translations/i18n';
import { hasImpersonationCookie, setImpersonationCookie, clearImpersonationCookie, isImpersonating, } from './impersonationSessionCookie';
const useImpersonationSessionGuard = () => {
    const dispatch = useDispatch();
    const impersonationDetails = useSelector((state) => state.User.impersonationDetails);
    const hasCheckedInitialRef = useRef(false);
    const wasImpersonatingInThisTabRef = useRef(false);
    const staleAccessTokenRef = useRef(null);
    const isStaleCleanupDoneRef = useRef(false);
    useEffect(() => {
        const impersonatingNow = isImpersonating(impersonationDetails);
        if (!hasCheckedInitialRef.current) {
            hasCheckedInitialRef.current = true;
            if (impersonatingNow && !hasImpersonationCookie()) {
                const isOpeningImpersonationLink = window.location.pathname.includes('adminDashboard')
                    && new URLSearchParams(window.location.search).has('token');
                if (!isOpeningImpersonationLink) {
                    utility.alert(i18n.t('GENERIC_STRINGS.PreviousSessionEnded', { ns: 'global' }), constants.TOAST_TYPES.INFO);
                }
                const staleAccessToken = store.getState().User.session.accessToken;
                staleAccessTokenRef.current = staleAccessToken;
                api_service.get({ endPoint: api_urls.LOGOUT, showLoader: true }).catch(() => { }).finally(() => {
                    const currentUser = store.getState().User;
                    if (currentUser.isLoggedIn && currentUser.session.accessToken === staleAccessToken) {
                        dispatch(app_actions.resetStoreNoReload());
                    }
                    isStaleCleanupDoneRef.current = true;
                });
                return;
            }
        }
        const isStaleSession = Boolean(staleAccessTokenRef.current)
            && store.getState().User.session.accessToken === staleAccessTokenRef.current;
        if (impersonatingNow && isStaleSession) {
            if (isStaleCleanupDoneRef.current) {
                dispatch(app_actions.resetStoreNoReload());
            }
            return;
        }
        if (impersonatingNow) {
            setImpersonationCookie();
            wasImpersonatingInThisTabRef.current = true;
        }
        else if (wasImpersonatingInThisTabRef.current) {
            clearImpersonationCookie();
            wasImpersonatingInThisTabRef.current = false;
        }
    }, [impersonationDetails, dispatch]);
};
export default useImpersonationSessionGuard;
